import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { BankActionTypes, BankActions } from "../../../actionTypes/master/bankActionTypes";
import { createBankApi, editBankDataByIdApi, getBankDataByIdApi, getBankListApi } from "../../requests/master/bankRequests";
import { getBankList, setBankDataById, setBankList, setBankListPageCount } from "../../../actions/master/bankAction";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";


function* createBankHandler(action: BankActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createBankApi, action.payload);
    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getBankListHandler(action: BankActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");

    const { data } = yield call(getBankListApi, action.payload);

    if (data.status) {
      yield put(setBankList(data?.data?.rows));
      yield put(setBankListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getBankDataByIdHandler(action: BankActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getBankDataByIdApi, action.payload);
    if (data.status) {
      yield put(setBankDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editBankDataByIdHandler(action: BankActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editBankDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getBankList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// bank sagas
export default function* bankSaga() {
  yield takeLatest(BankActions.CREATE_BANK, createBankHandler);
  yield takeLatest(BankActions.GET_BANK_LIST, getBankListHandler);
  yield takeLatest(BankActions.GET_BANK_DATA_BY_ID, getBankDataByIdHandler);
  yield takeLatest(BankActions.EDIT_BANK_DATA_BY_ID, editBankDataByIdHandler);
}
